export default {
  install(Vue) {
    Vue.directive('elInputnumberDefault0', {
      inserted(el) {
        const inputNumber = el.querySelector('.el-input__inner')
        inputNumber.addEventListener("input", () => {
          if (!inputNumber.value) {
            inputNumber.value = 0
            inputNumber.dispatchEvent(new Event("input"))
          }
        })
        // inputNumber.removeEventListener("input", () => {})
      }
    })
  }
}


